// eslint-disable-next-line no-shadow
export enum LocalStorageKey {
  RecentSearches = 'recentSearches',
}
